import { useState, useCallback } from 'react';
import { SortOrder, SORT_ORDER } from '../constants';

export const useSortOrder = () => {
  /**
   * Controls which part of the time window to fetch from the API:
   * - OLDEST: Fetch logs from the start of the time window
   * - NEWEST: Fetch logs from the end of the time window
   * Used by LogScroller component.
   */
  const [querySortOrder, setQuerySortOrder] = useState<SortOrder>(SORT_ORDER.NEWEST);

  /**
   * Controls the display order of log lines in the UI:
   * - NEWEST: Show newest logs first (descending)
   * - OLDEST: Show oldest logs first (ascending)
   * Used by SortOrderSelector component.
   */
  const [viewSortOrder, setViewSortOrder] = useState<SortOrder>(SORT_ORDER.NEWEST);

  const handleSortOrderChange = useCallback((newSortOrder: SortOrder) => {
    setViewSortOrder(newSortOrder);
  }, []);

  return {
    querySortOrder,
    viewSortOrder,
    setQuerySortOrder,
    setViewSortOrder,
    handleSortOrderChange,
  };
};
